import React from "react";

export default function SiteFooter() {
  return (
    <footer style={{
      width: "100%",
      maxWidth: 520,
      margin: "32px auto 0",
      padding: "20px 20px 48px",
      borderTop: "1px solid #e0d5c8",
      boxSizing: "border-box",
    }}>
      <div style={{
        fontSize: "0.72rem",
        color: "#9c7b5a",
        lineHeight: 2.1,
        marginBottom: 14,
      }}>
        <span style={{ color: "#7a6654", fontWeight: 700 }}>상호명</span>: 우연 &nbsp;|&nbsp;{" "}
        <span style={{ color: "#7a6654", fontWeight: 700 }}>대표자</span>: 김나연 &nbsp;|&nbsp;{" "}
        <span style={{ color: "#7a6654", fontWeight: 700 }}>사업자등록번호</span>: 517-04-03594<br />
        <span style={{ color: "#7a6654", fontWeight: 700 }}>통신판매업신고번호</span>: 제 2026-서울영등포-1388호 &nbsp;|&nbsp;{" "}
        <span style={{ color: "#7a6654", fontWeight: 700 }}>연락처</span>: 010-4282-2377<br />
        <span style={{ color: "#7a6654", fontWeight: 700 }}>사업장 주소</span>: 서울시 영등포구 도림로 125가길 14 1층 우연사주<br />
        <span style={{ color: "#7a6654", fontWeight: 700 }}>이메일</span>: wooyeonsaju@gmail.com
      </div>
      <div style={{ display: "flex", flexWrap: "wrap", gap: "6px 14px" }}>
        <a href="/legal/terms" target="_blank" rel="noreferrer"
          style={{ fontSize: "0.72rem", color: "#9c7b5a", textDecoration: "underline" }}>
          이용약관
        </a>
        <a href="/legal/privacy" target="_blank" rel="noreferrer"
          style={{ fontSize: "0.72rem", color: "#9c7b5a", textDecoration: "underline" }}>
          개인정보 처리방침
        </a>
        <a href="/legal/refund" target="_blank" rel="noreferrer"
          style={{ fontSize: "0.72rem", color: "#9c7b5a", textDecoration: "underline" }}>
          환불정책
        </a>
      </div>
    </footer>
  );
}
